/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_appsync_graphqlEndpoint:
    "https://eop4kchrnfc4dc4avue7t5hg7u.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-7ugvgumxpjdfngxvkuqppba2wu",

  aws_cognito_identity_pool_id:
    "us-east-1:ce937a01-83d0-44de-a73a-a9f80f7a3e3e",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_envCctF4r",
  aws_user_pools_web_client_id: "2a2d8pv8v7119qth5knhefcrs1",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export default awsmobile;
